import api from './api';

export const authService = {
  register: async (userData) => {
    const response = await api.post('/register', userData);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  login: async (credentials) => {
    const response = await api.post('/login', credentials);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Worker picks their name on the farm's worker link and enters their PIN
  workerSignIn: async (linkToken, { userId, pin }) => {
    // Never queue a sign-in offline; it has to reach the server
    const response = await api.post(
      `/public/worker-sign-in/${linkToken}`,
      { user_id: userId, pin },
      { __skipOfflineQueue: true },
    );
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  logout: async (originalAdminToken = null) => {
    try {
      const payload = {};
      if (originalAdminToken) {
        payload.original_admin_token = originalAdminToken;
      }
      await api.post('/logout', payload);
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Clear impersonation data
      localStorage.removeItem('original_admin_token');
      localStorage.removeItem('original_admin_user');
    }
  },

  getCurrentUser: async () => {
    const response = await api.get('/me');
    return response.data;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  getStoredUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  forgotPassword: async (email) => {
    const response = await api.post('/forgot-password', { email });
    return response.data;
  },

  resetPassword: async (token, email, password, passwordConfirmation) => {
    const response = await api.post('/reset-password', {
      token,
      email,
      password,
      password_confirmation: passwordConfirmation,
    });
    return response.data;
  },
};

